// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/@anchor/react-components/dist/lib/css/global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --mp-font-family: "Maersk Text",
  -apple-system,
  BlinkMacSystemFont,
  "Microsoft JhengHei",
  "Microsoft Yahei",
  "微软雅黑",
  STXihei,
  "华文细黑",
  sans-serif;
  --background-color-grey: #fafafa;
  --border-color:#DBDBDB;
  --border-haeder-color:#CFCFCF;
  --bg-color-lightgray:rgb(247, 247, 247);
  --color-mainBg: #f7f7f7;
  --color-white: #ffffff;
  --color-black: #000000;
  --color-green: #56ad56;
  --color-red: red;
  --color-yellow: #56ad56;
  --color-light-gray:#e5e5e5;
  --color-dark-gray:#4e4e4e;
  --color-font:#141414;
  --color-maersk-darkblue:#01263f;
  --color-text-grey: #878787;
  --color-maersk-blue:#42b0d5;
  --color-lightGreen: #C5E5C2;
  --color-lightRed:#E9B2B7;
  --color-light-blue:#f6fcff;
  --font-size-xs:10px;
  --font-size-sm:12px;
  --font-size-md:14px;
  --font-size-lg:16px;
  --font-size-xl:18px;
  --table-header-bg:#f4fcff;
  --time-zone-text-color: #25667c;
  --table-input-border-color:#b8c5cf;
  --table-column-border-select-color:#0073AB;
  --table-column-border-option-color:#328529;
  --table-select-bg-color:#E9F6FC;
  --table-select-option-bg-color:#DCF6D9;
  --btn-color: #00243d;
  --status-approved: #c5e5c2;
  --status-default: #7fd5f1;
  --status-active: #a3e99d;
  --status-approval: #c5e5c2;
  --status-terminated: #fc7152;
  --status-reject: #ffa28d;
  --status-planning: #ffebab;
  --status-scheduling: #ffeba8;
  --status-expired: #ffa28d;
  --status-design: #83d6cf;
  --performa-option-active: #ffffff;
  --performa-option-hover: #f4faff;
  --performa-option-disabled: #f3f3f3;
  --performa-option-disabled-color: #ccc;
  --chat-box-color: #f2f2f2;
  --chat-box-border-color: #ccc;
  --chat-box-input-color: #f4f7f9;
  --info-formula-highlight: #646464;
  --info-formula-highlight-bg: #EDEDED;
  --bar-chart-dtco-count-color: #6A91BC;
  --bar-chart-phase-in-color: #F28E2A;
  --lighter-green: #f2fbf1;
}

body {
  position: relative;
  min-height: 100%;
  overflow-x: hidden;
  margin: 0;
  color: var(--color-font);
  font-size: var(--mp-font-size);
  font-family: var(--mp-font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--color-mainBg) !important;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE;;;;;;;;YAAA;EASA,gCAAA;EACA,sBAAA;EACA,6BAAA;EACA,uCAAA;EAEA,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,wBAAA;EACA,0BAAA;EAGA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,yBAAA;EACA,+BAAA;EACA,kCAAA;EACA,0CAAA;EACA,0CAAA;EACA,+BAAA;EACA,sCAAA;EACA,oBAAA;EAEA,0BAAA;EACA,yBAAA;EACA,wBAAA;EACA,0BAAA;EACA,4BAAA;EACA,wBAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,wBAAA;EACA,iCAAA;EACA,gCAAA;EACA,mCAAA;EACA,sCAAA;EACA,yBAAA;EACA,6BAAA;EACA,+BAAA;EACA,iCAAA;EACA,oCAAA;EACA,qCAAA;EACA,mCAAA;EACA,wBAAA;AAJF;;AAMA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,mCAAA;EACA,kCAAA;EACA,gDAAA;AAHF","sourcesContent":["@use './Styles/mixins.scss';\n@import '@anchor/react-components/dist/lib/css/global.css';\n:root {\n  --mp-font-family: \"Maersk Text\",\n  -apple-system,\n  BlinkMacSystemFont,\n  \"Microsoft JhengHei\",\n  \"Microsoft Yahei\",\n  \"微软雅黑\",\n  STXihei,\n  \"华文细黑\",\n  sans-serif;\n  --background-color-grey: #fafafa;\n  --border-color:#DBDBDB;\n  --border-haeder-color:#CFCFCF;\n  --bg-color-lightgray:rgb(247, 247, 247);\n\n  --color-mainBg: #f7f7f7;\n  --color-white: #ffffff;\n  --color-black: #000000;\n  --color-green: #56ad56;\n  --color-red: red;\n  --color-yellow: #56ad56;\n  --color-light-gray:#e5e5e5;\n  --color-dark-gray:#4e4e4e;\n  --color-font:#141414;\n  --color-maersk-darkblue:#01263f;\n  --color-text-grey: #878787;\n  --color-maersk-blue:#42b0d5;\n  --color-lightGreen: #C5E5C2;\n  --color-lightRed:#E9B2B7;\n  --color-light-blue:#f6fcff;\n\n\n  --font-size-xs:10px;\n  --font-size-sm:12px;\n  --font-size-md:14px;\n  --font-size-lg:16px;\n  --font-size-xl:18px;\n\n  --table-header-bg:#f4fcff;\n  --time-zone-text-color: #25667c;\n  --table-input-border-color:#b8c5cf;\n  --table-column-border-select-color:#0073AB;\n  --table-column-border-option-color:#328529;\n  --table-select-bg-color:#E9F6FC;\n  --table-select-option-bg-color:#DCF6D9;\n  --btn-color: #00243d;\n  \n  --status-approved: #c5e5c2;\n  --status-default: #7fd5f1;\n  --status-active: #a3e99d;\n  --status-approval: #c5e5c2;\n  --status-terminated: #fc7152;\n  --status-reject: #ffa28d;\n  --status-planning: #ffebab;\n  --status-scheduling: #ffeba8;\n  --status-expired: #ffa28d;\n  --status-design: #83d6cf;\n  --performa-option-active: #ffffff;\n  --performa-option-hover: #f4faff;\n  --performa-option-disabled: #f3f3f3;\n  --performa-option-disabled-color: #ccc;\n  --chat-box-color: #f2f2f2;\n  --chat-box-border-color: #ccc;\n  --chat-box-input-color: #f4f7f9;\n  --info-formula-highlight: #646464;\n  --info-formula-highlight-bg: #EDEDED;\n  --bar-chart-dtco-count-color: #6A91BC;\n  --bar-chart-phase-in-color: #F28E2A;\n  --lighter-green: #f2fbf1;\n}\nbody {\n  position: relative;\n  min-height: 100%;\n  overflow-x: hidden;\n  margin: 0;\n  color: var(--color-font);\n  font-size: var(--mp-font-size);\n  font-family: var(--mp-font-family);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--color-mainBg) !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
